import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { currentI18nLocale } from '@/composition/useLangSet';

import LogoRu from './Logos/Ru.vue';
import LogoEn from './Logos/En.vue';
import LogoMobile from './Logos/Mobile.vue';

type Component = InstanceType<typeof LogoRu> | InstanceType<typeof LogoEn>;


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLogo',
  setup(__props) {

const logosMapper: Record<string, Component> = { ru: LogoRu, en: LogoEn };

const Logo = computed<Component>(
  () => logosMapper[currentI18nLocale.value] || LogoEn
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(Logo.value), { class: "logo_link__image" })),
    _createVNode(LogoMobile, { class: "logo_link__image_mobile" })
  ], 64))
}
}

})